import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getKasm() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {}; 
    appendTokenName(data); 
    return apiAction({
        types: ["GET_KASM_REQUESTED", "GET_KASM_SUCCESS", "GET_KASM_FAILED"],
        method: "POST",
        path: "admin/get_kasms",
        body: data
    });
}

export function getKasmId(kasm_id) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_kasm = {"kasm_id": kasm_id};   
    appendTokenName(data); 
    return apiAction({
        types: ["GET_KASM_ID_REQUESTED", "GET_KASM_ID_SUCCESS", "GET_KASM_ID_FAILED"],
        method: "POST",
        path: "admin/get_kasm",
        body: data
    });
}




// WEBPACK FOOTER //
// ./src/actions/actionKasm.js